import axios from "axios";
import { encryptData, decryptData } from "../helpers/crypto";

const axiosInstance = axios.create({
  baseURL: "https://ramrummyapi.shyammatka.co.in/api/v1",
  // baseURL: "http://192.168.1.27:5000/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // ✅ FormData (file uploads) ke liye encryption SKIP karo
  if (config.data instanceof FormData) {
    // Content-Type header ko hatna zaroori hai —
    // browser khud boundary ke saath set karega
    delete config.headers["Content-Type"];
    return config;
  }

  // Normal JSON requests ke liye encryption (jaisa pehle tha)
  if (config.data) {
    config.data = {
      payload: encryptData(config.data),
    };
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data.payload) {
      response.data = decryptData(response.data.payload);
    }

    return response;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
